import { MessageTimestamp, MessageTimestampProps } from 'stream-chat-react';

export const CustomMessageTimestamp = (props: MessageTimestampProps) => (
  <MessageTimestamp {...props} calendar={false} format={'DD-MM-YYYY, HH:mm'} />
);
